import { CustomerRepository } from "../../repositories/CustomerRepository";
import { CustomerDetailResult } from "../../entities/CustomerEntity";

/**
 * Get Customer By ID Use Case
 * Retrieves a single customer by their ID
 */
export class GetCustomerByIdUseCase {
  constructor(private repository: CustomerRepository) {}

  async execute(customerId: string): Promise<CustomerDetailResult> {
    // Validate customer ID
    if (!customerId || customerId.trim() === "") {
      throw new Error("Customer ID is required");
    }

    return await this.repository.getCustomerById(customerId);
  }
}

